import "../../styles/modal.css";

export default function DocumentDeleteModal({ document, onClose, onConfirm }) {
  if (!document) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div
        className="modalCard modalDanger"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modalDangerTitle">Supprimer le Type de Document</h3>

        <p className="modalDangerText">
          Êtes-vous sûr de vouloir supprimer
          <strong> {document.name}</strong> ?
        </p>

        <p className="modalDangerWarning">
          Cette action est irréversible.
        </p>

        <div className="modalActions">
          <button className="btnGhost" onClick={onClose}>
            Annuler
          </button>

          <button
            className="btnDanger"
            onClick={() => onConfirm(document.id)}>
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
